import { Link } from "react-router-dom";
import { Heart, Users, BookOpen, GraduationCap, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    icon: Heart,
    slug: "before-the-vows",
    title: "Pre-Marriage counseling",
    program: "Before the Vows",
    body: "A custom curriculum I built specifically for Oneness Apostolic couples — biblical, practical, and rooted in our shared doctrine.",
    available: true,
  },
  {
    icon: Users,
    slug: "marriage-mentoring",
    title: "Couple & marriage counseling",
    program: "Dare to be Different · Certified Mentors",
    body: "Christ-centered mentoring for couples in every season — newly married, weathered, or walking through crisis. $100 per 90-min session.",
    available: true,
  },
  {
    icon: BookOpen,
    slug: "individual",
    title: "Individual counseling",
    program: "Certified Biblical Counselor",
    body: "Scripture-grounded one-on-one care for life's hard chapters — anxiety, grief, decisions, identity, spiritual growth. Single sessions or a 4-session Growth Journey.",
    available: true,
  },
  {
    icon: GraduationCap,
    slug: "seminars",
    title: "Marriage seminars",
    body: "Including the certified Love & Respect Marriage Seminar — bring it to your church, retreat, or small group.",
    available: false,
  },
];

export default function Counseling() {
  return (
    <div data-testid="counseling-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-10 md:py-20">
        <div className="overline mb-4">Biblical & Pastoral Counseling</div>
        <h1 className="font-serif-display tracking-[-0.045em] leading-[0.88]" style={{ color: "var(--ink)" }}>
          <span className="block text-5xl sm:text-6xl lg:text-9xl">BIBLICAL</span>
          <span className="block text-5xl sm:text-6xl lg:text-9xl">
            <span className="font-serif-display-italic" style={{ color: "var(--ember)" }}>counseling.</span>
          </span>
        </h1>
        <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed" style={{ color: "var(--ink-2)" }}>
          I'm a <strong style={{ color: "var(--ink)" }}>Certified Biblical Counselor</strong> and a Board Certification
          candidate. Samantha and I serve couples and individuals together — with scripture as the standard and
          the gospel as the goal.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-24 grid grid-cols-1 md:grid-cols-2 gap-10">
        {SERVICES.map((s, i) => {
          const cardClasses = "card-surface p-8 lg:p-10 block group cursor-pointer";
          const inner = (
            <>
              <div className="flex items-start justify-between gap-3">
                <div className="overline">0{i + 1}</div>
                {s.available ? (
                  <span className="text-[0.65rem] uppercase tracking-[0.2em]" style={{ color: "var(--ember)" }}>Learn more →</span>
                ) : (
                  <span className="text-[0.65rem] uppercase tracking-[0.2em]" style={{ color: "var(--muted)" }}>Coming soon</span>
                )}
              </div>
              <s.icon size={28} strokeWidth={1.5} className="mt-3" style={{ color: "var(--ember)" }} />
              <h3 className="font-serif-display text-3xl mt-4 leading-tight group-hover:text-[var(--ember)] transition-colors" style={{ color: "var(--ink)" }}>
                {s.title}
              </h3>
              {s.program && (
                <p className="mt-1 font-serif-display-italic text-base" style={{ color: "var(--gold)" }}>
                  {s.program}
                </p>
              )}
              <p className="mt-3 leading-relaxed" style={{ color: "var(--ink-2)" }}>{s.body}</p>
            </>
          );
          return s.available ? (
            <Link key={i} to={`/counseling/${s.slug}`} data-testid={`counseling-card-${s.slug}`} className={cardClasses}>
              {inner}
            </Link>
          ) : (
            <div key={i} data-testid={`counseling-card-${s.slug}`} className={cardClasses} style={{ opacity: 0.7 }}>
              {inner}
            </div>
          );
        })}
      </section>

      <section style={{ background: "var(--bg-alt)" }}>
        <div className="max-w-4xl mx-auto px-6 lg:px-12 py-12 md:py-24 text-center">
          <div className="overline mb-4">Credentials</div>
          <h2 className="font-serif-display text-3xl md:text-5xl tracking-tight leading-tight" style={{ color: "var(--ink)" }}>
            Trained, certified, and accountable.
          </h2>
          <ul className="mt-10 space-y-3 text-base md:text-lg" style={{ color: "var(--ink-2)" }}>
            <li>· Certified Biblical Counselor</li>
            <li>· Board Certification Candidate</li>
            <li>· Certified Love &amp; Respect Marriage Seminar leaders</li>
            <li>· Custom Pre-Marriage curriculum for Oneness Apostolic couples</li>
          </ul>
          <a href="mailto:thedisciplelifems@gmail.com" data-testid="counseling-contact-button" className="btn-primary mt-12 inline-flex">
            Schedule a conversation
          </a>
        </div>
      </section>
    </div>
  );
}
